'use client'

// 'use client' is needed to avoid error: "useState only works in Client Components"

import { Animation } from '@vinted/web-ui'

import animation from '../assets/search-empty-state.json'

const EmptyAnimation = () => (
  <div className="user-followers__empty-animation">
    <Animation animationData={animation} />
  </div>
)

export default EmptyAnimation
